<template>
  <div class="manufacturerslist-container">
    <div class="search-layout">
      <div class="search-layout-content">
        <div class="search-layout-item1" v-if="userinfo.tenantType === 0 || userinfo.tenantType === 1">
          <div>{{ $t('manage.name65') }}</div>
          <el-select v-model="queryInfo.grandParentId" :placeholder="$t('public.name1')" @change="getMerchantList(1)" clearable>
            <el-option v-for="item in manufacturerOptions" :key="item.tenantId" :label="item.tenantName" :value="item.tenantId"> </el-option>
          </el-select>
        </div>

        <div class="search-layout-item2" v-if="userinfo.tenantType === 0 || userinfo.tenantType === 1">
          <div>{{ $t('manage.name86') }}</div>
          <el-select v-model="queryInfo.parentId" :placeholder="$t('public.name1')" @change="getTenantList" clearable>
            <el-option v-for="item in merchantOptions" :key="item.tenantId + ''" :label="item.tenantName" :value="item.tenantId + ''"> </el-option>
          </el-select>
        </div>
        <div class="search-layout-item3">
          <div>{{ $t('manage.name90') }}</div>
          <el-input class="input-layout" v-model="queryInfo.tenantName" :placeholder="$t('public.name5')" clearable> </el-input>
        </div>

        <div class="search-layout-item4">
          <div>{{ $t('manage.name2') }}</div>
          <el-select v-model="queryInfo.status" :placeholder="$t('public.name1')" style="width:130px;" @change="getTenantList">
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </div>
      </div>
      <div class="bt-layout">
        <el-button type="primary" size="medium" @click="getPageList" v-if="buttonPerms.indexOf('tenant/list') > -1">{{ $t('public.name3') }}</el-button>
        <el-button size="medium" @click="resetQueryInfo">{{ $t('public.name4') }}</el-button>
      </div>
    </div>
    <div class="add-user">
      <el-button type="primary" icon="el-icon-plus" size="medium" @click="addUser(null)" v-if="buttonPerms.indexOf('tenant/add') > -1">{{ $t('manage.name74') }}</el-button>
    </div>
    <el-table :data="tableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading">
      <el-table-column :label="$t('manage.name91')" prop="tenantName" sortable width="120"></el-table-column>
      <el-table-column :label="$t('manage.name79')" prop="parentName" sortable></el-table-column>
      <el-table-column :label="$t('manage.name68')" prop="createTime" sortable></el-table-column>
      <el-table-column :label="$t('manage.name80')" prop="parentTenantType" sortable>
        <template slot-scope="scope">
          <div v-if="scope.row.parentTenantType === 20">{{ $t('manage.name120') }}</div>
          <div v-if="scope.row.parentTenantType === 21">{{ $t('manage.name121') }}</div>
          <div v-if="scope.row.parentTenantType === 22">{{ $t('manage.name129') }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name5')" prop="grandParentName" sortable></el-table-column>
      <el-table-column :label="$t('manage.name92')" prop="merchantNum" sortable width="140">
        <template slot-scope="scope">
          <div class="click-pointer" @click="cellClick(1, scope.row)">{{ scope.row.merchantNum }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('manage.name70')" prop="modelNum" sortable>
        <template slot-scope="scope">
          <div class="click-pointer" @click="cellClick(1, scope.row)">{{ scope.row.modelNum }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('manage.name82')" prop="remark"></el-table-column>
      <el-table-column :label="$t('manage.name83')" prop="status" sortable width="140">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.status" active-color="#0f73e6" inactive-color="#dcdfe6" @change="changeSwitch(scope.row, $event)"> </el-switch>
        </template>
      </el-table-column>
      <el-table-column :label="$t('manage.name130')" prop="address">
        <template slot-scope="scope">
         <div>{{ scope.row.address }}{{ scope.row.houseNumber }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('manage.name131')" prop="contactNumber"></el-table-column>
      <el-table-column :label="$t('manage.name15')" width="188px" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="goFranchiseesUserList(scope.row)">{{ $t('manage.name93') }}</el-button>
          <el-button type="text" @click="addUser(scope.row)" v-if="buttonPerms.indexOf('tenant/edit') > -1">{{ $t('manage.name17') }}</el-button>
          <el-button type="text" @click="delUser(scope.row)" v-if="buttonPerms.indexOf('tenant/delete') > -1" style="color:#ea4646">{{ $t('manage.name18') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="queryInfo.limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <el-dialog :title="type ===1 ? $t('manage.name135') : $t('manage.name136')" v-if="franchiseInfoDialog" :visible.sync="franchiseInfoDialog" :close-on-click-modal ="false" :before-close="close" width="60%">
      <el-form ref="franchiseFormRef" :model="franchiseInfo" :rules="userinfo.tenantType ===3 ? franchiseInfoRules1: franchiseInfoRules" label-width="110px">
        <el-form-item prop="grandParentId" :label="$t('manage.name65')" v-if="userinfo.tenantType ===0">
          <el-select v-model="franchiseInfo.grandParentId" :placeholder="$t('public.name1')" style="width:100%;" @change="getMerchantList(2)">
            <el-option v-for="item in manufacturerOptions" :key="item.tenantId" :label="item.tenantName" :value="item.tenantId"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="parentId" :label="$t('manage.name86')" v-if="userinfo.tenantType ===0">
          <el-select v-model="franchiseInfo.parentId" :placeholder="$t('public.name1')" style="width:100%;" @change="changeMerchant">
            <el-option v-for="item in merchantOptions" :key="item.tenantId" :label="item.tenantName" :value="item.tenantId"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="tenantName" :label="$t('manage.name90')">
          <el-input v-model="franchiseInfo.tenantName" :placeholder="$t('public.name5')"></el-input>
        </el-form-item>
        <el-form-item prop="address" :label="$t('manage.name132')">
          <div>
            {{ detailsAddress}}
          </div>
          <el-input v-model="franchiseInfo.houseNumber" :placeholder="$t('manage.name134')"></el-input>
        </el-form-item>
        <el-form-item>
          <MapComponets></MapComponets>
        </el-form-item>
        <el-form-item prop="contactNumber" :label="$t('manage.name133')">
          <el-input v-model="franchiseInfo.contactNumber" :placeholder="$t('public.name5')"></el-input>
        </el-form-item>
        <el-form-item prop="remark" :label="$t('manage.name78')">
          <el-input v-model="franchiseInfo.remark" :placeholder="$t('public.name5')"></el-input>
        </el-form-item>

        <el-form-item prop="status" :label="$t('manage.name2')">
          <el-switch v-model="franchiseInfo.status" active-color="#0f73e6" inactive-color="#dcdfe6"> </el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm" :loading="loading">{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { tenantList, tenantAdd, tenantEdit, tenantStatus, tenantDelete } from '@/api/manage.js'
import { mapGetters } from 'vuex'
import MapComponets from './mapComponets.vue'
import coordtransform from 'coordtransform'
export default {
  components: {
    MapComponets
  },
  computed: {
    ...mapGetters(['userinfo'])
  },
  data() {
    return {
      manufacturerOptions: [],
      merchantOptions: [],
      detailsAddress: '',
      queryInfo: {
        parentId: '',
        tenantId: '',
        tenantName: '',
        page: 1,
        limit: 10,
        status: 2
      },
      tableLoading: false,
      loading: false,
      tableList: [],
      statusOptions: [
        {
          value: 2,
          label: this.$t('public.name19')
        },
        {
          value: 0,
          label: this.$t('manage.name13')
        },
        {
          value: 1,
          label: this.$t('manage.name14')
        }
      ],
      total: 0,
      franchiseInfoRules: {
        grandParentId: [
          {
            required: true,
            message: this.$t('bike.name476'),
            trigger: 'blur'
          }
        ],
        parentId: [
          {
            required: true,
            message: this.$t('bike.name481'),
            trigger: 'blur'
          }
        ],
        address: [
          {
            required: true,
            message: this.$t('screen.name26'),
            trigger: 'blur'
          }
        ],
        contactNumber: [
          {
            required: true,
            message: this.$t('screen.name27'),
            trigger: 'blur'
          }
        ],
        tenantName: [
          {
            required: true,
            message: this.$t('screen.name28'),
            trigger: 'blur'
          }
        ]
      },

      franchiseInfoRules1: {
        tenantName: [
          {
            required: true,
            message: this.$t('screen.name28'),
            trigger: 'blur'
          }
        ]
      },

      franchiseInfo: {
        grandParentId: '',
        parentId: '',
        tenantName: '',
        remark: '',
        address: '',
        province: '',
        city: '',
        region: '',
        houseNumber: '',
        lng: '',
        lat: '',
        contactNumber: '',
        status: true,
        tenantId: '',
        tenantType: 3
      },
      franchiseInfoDialog: false,
      buttonPerms: '',
      type: 1
    }
  },
  created() {
    this.buttonPerms = localStorage.getItem('buttonPerms')
    this.$bus.$on('addressInfo', (addressInfo) => {
      this.detailsAddress = addressInfo.address
      this.franchiseInfo.address = addressInfo.address
      this.franchiseInfo.province = addressInfo.province
      this.franchiseInfo.city = addressInfo.city
      this.franchiseInfo.region = addressInfo.region
      this.franchiseInfo.lng = addressInfo.lng
      this.franchiseInfo.lat = addressInfo.lat
    })
  },
  mounted() {
    this.getTenantList()
    this.getManufacturerList()
  },
  beforeDestroy() {
    this.$bus.$off('addressInfo')
  },
  methods: {
    getPageList() {
      this.queryInfo.page = 1
      this.queryInfo.limit = 10
      this.getTenantList()
    },
    getTenantList() {
      this.tableLoading = true
      const data = {
        page: this.queryInfo.page,
        limit: this.queryInfo.limit,
        tenantType: 3
      }

      if (this.queryInfo.tenantName) {
        data.tenantName = this.queryInfo.tenantName.trim()
      }

      if (this.queryInfo.parentId) {
        data.parentId = this.queryInfo.parentId
      }

      if (this.queryInfo.grandParentId) {
        data.grandParentId = this.queryInfo.grandParentId
      }

      if (this.queryInfo.status !== 2) {
        if (this.queryInfo.status === 0) {
          data.status = true
        } else {
          data.status = false
        }
      }

      tenantList(data)
        .then(res => {
          this.tableList = res.data.list
          this.total = res.data.total
          this.tableLoading = false
        })
        .catch(() => {
          this.tableList = []
          this.total = 0
          this.tableLoading = false
        })
    },

    resetQueryInfo() {
      this.queryInfo = {
        parentId: '',
        tenantId: '',
        tenantName: '',
        page: 1,
        limit: 10,
        status: 2
      }
      this.getTenantList()
    },

    getManufacturerList() {
      const data = {
        page: 1,
        limit: 500,
        tenantType: 1
      }

      tenantList(data)
        .then(res => {
          this.manufacturerOptions = res.data.list
          this.getMerchantList(2)
        })
        .catch(() => {
          this.manufacturerOptions = []
        })
    },

    getMerchantList(type) {
      const data = {
        page: 1,
        limit: 500,
        tenantType: 2,
        parentId: type === 1 ? this.queryInfo.grandParentId : this.franchiseInfo.grandParentId
      }

      tenantList(data)
        .then(res => {
          if (this.type === 1) {
            this.franchiseInfo.parentId = ''
          }
          this.queryInfo.parentId = ''
          this.merchantOptions = res.data.list
        })
        .catch(() => {
          this.merchantOptions = []
        })
    },

    addUser(row) {
      if (row !== null) {
        const bikepointbaidu = coordtransform.wgs84togcj02(row.lng, row.lat)
        const bikepointsbaidu = coordtransform.gcj02tobd09(bikepointbaidu[0], bikepointbaidu[1])
        this.type = 2
        this.franchiseInfo = {
          grandParentId: row.grandParentId,
          parentId: row.parentId,
          tenantName: row.tenantName,
          remark: row.remark,
          status: row.status,
          tenantId: row.tenantId,
          tenantType: row.tenantType,
          province: row.province,
          city: row.city,
          region: row.region,
          houseNumber: row.houseNumber,
          address: row.address,
          lng: Number(bikepointsbaidu[0]),
          lat: Number(bikepointsbaidu[1]),
          contactNumber: row.contactNumber
        }
        this.detailsAddress = row.address
      } else {
        this.franchiseInfo.grandParentId = this.queryInfo.grandParentId
        this.type = 1
      }
      // const data = {
      //   page: 1,
      //   limit: 500,
      //   tenantType: 2,
      //   parentId: this.franchiseInfo.grandParentId
      // }

      // tenantList(data)
      //   .then(res => {
      //     this.franchiseInfo.parentId = row.parentId
      //     this.merchantOptions = res.data.list
      //   })
      //   .catch(() => {
      //     this.merchantOptions = []
      //   })
      this.franchiseInfoDialog = true
    },

    delUser(row) {
      this.$confirm(this.$t('manage.name137'), this.$t('public.name23'), {
        confirmButtonText: this.$t('public.name25'),
        cancelButtonText: this.$t('public.name14'),
        type: 'warning'
      })
        .then(() => {
          tenantDelete({ tenantId: row.tenantId })
            .then(res => {
              this.loading = false
              if (res.code === 200) {
                this.close()
                this.getTenantList()
              }
            })
            .catch(() => {
              this.loading = false
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('public.name31')
          })
        })
    },
    close() {
      this.franchiseInfoDialog = false
      this.franchiseInfo = {
        parentParentId: '',
        parentId: '',
        tenantName: '',
        address: '',
        province: '',
        city: '',
        region: '',
        houseNumber: '',
        lng: '',
        lat: '',
        contactNumber: '',
        remark: '',
        status: true,
        tenantId: '',
        tenantType: 3
      }
      this.detailsAddress = ''
    },
    changeMerchant(e) {
      this.merchantOptions.map((item) => {
        if (item.tenantId === e) {
          if (item.tenantType === 20) {
            this.franchiseInfo.tenantType = 30
          } else if (item.tenantType === 21) {
            this.franchiseInfo.tenantType = 31
          } else if (item.tenantType === 22) {
            this.franchiseInfo.tenantType = 32
          }
        }
      })
    },
    submitForm() {
      this.$refs.franchiseFormRef.validate(async valid => {
        if (!valid) return
        this.loading = true
        if (this.type === 1) {
          tenantAdd(this.franchiseInfo)
            .then(res => {
              this.loading = false
              if (res.code === 200) {
                this.close()
                this.getTenantList()
              }
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          tenantEdit(this.franchiseInfo)
            .then(res => {
              this.loading = false
              if (res.code === 200) {
                this.close()
                this.getTenantList()
              }
            })
            .catch(() => {
              this.loading = false
            })
        }
      })
    },

    changeSwitch(row, e) {
      this.tableLoading = true
      tenantStatus({ tenantId: row.tenantId })
        .then(res => {
          this.tableLoading = false
        })
        .catch(() => {
          this.tableLoading = false
        })
    },

    cellClick(type, row) {
      console.log('row==', row)
      if (type === 1) {
      }

      if (type === 2) {
      }
    },
    goFranchiseesUserList(row) {
      this.$router.push({ path: '/franchiseesuserlist', query: { grandParentId: row.grandParentId, parentId: row.parentId, tenantId: row.tenantId } })
    },

    // 监听pagesizes的事件
    handleSizeChange(newSize) {
      this.queryInfo.limit = newSize
      this.getTenantList()
    },
    // 监听页码值改变事件
    handleCurrentChange(newPage) {
      this.queryInfo.page = newPage
      this.getTenantList()
    }
  }
}
</script>
<style lang="scss" scoped>
.manufacturerslist-container {
  width: 100%;
  display: flex;
  flex-direction: column;

  .click-pointer {
    cursor: pointer;
  }

  .search-layout {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
    .bt-layout {
      display: flex;
      flex-direction: row;
      height: 36px;
    }
    .search-layout-content {
      display: flex;
      flex-direction: row;

      .search-layout-item1 {
        display: flex;
        flex-direction: row;
        align-items: center;
        > :first-child {
          font-size: 14px;
          width: 84px;
        }
      }

      .search-layout-item2 {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-left: 23px;
        > :first-child {
          font-size: 14px;
          width: 84px;
        }
      }
      .search-layout-item3 {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-left: 23px;
        > :first-child {
          font-size: 14px;
          width: 106px;
        }
      }
      .search-layout-item4 {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-left: 23px;
        > :first-child {
          font-size: 14px;
          width: 48px;
        }
      }
    }

    .input-layout {
      width: 80%;
    }
  }

  .qiyong {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #ebf6ed;
    color: #39ab4c;

    .text:before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 2px;
      background: #39ab4c;
      margin-right: 5px;
    }
  }

  .jinyong {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #fcecec;
    color: #ea4646;

    .text:before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 2px;
      background: #ea4646;
      margin-right: 5px;
    }
  }
}
</style>
